export default __webpack_public_path__ + "static/media/Linacon-5-eng.fd0f7431.jpg";